<article>
  <!-- discover building -->

  <section class="no-print">
    <!--
    <div class="text-right">
      <select [(ngModel)]="selectedReview" class="existing-reviews" (change)="selectExistingReview($event)">
        <option [ngValue]="undefined">Select an existing review...</option>
        <option *ngFor="let review of reviewList" [value]="review.id">{{review.title}} ({{review.collectionTitle}})
        </option>
      </select>
    </div>
    -->

    <app-theme-page-section>
      <div class="building-review-select">
        <div>
          <app-select-building (onBuildingChanged)="buildingChanged($event)" (onBuildingSelected)="buildingSelected($event)" (onReviewSelected)="reviewSelected($event)"> </app-select-building>
        </div>
        <div></div>
      </div>
    </app-theme-page-section>
  </section>

  <!-- Building details -->
  @if (building && !collectionForAssets?.hasCollections && !isLoading) {
    <section class="no-print">
      <div>
        <p>No asset collection</p>
        There is no defined collection of assets for this building, to proceed create the collection of assets required for the report.
        <!--       <app-theme-page-section>
        <app-collection-assets type="reporting" [building]="building"></app-collection-assets>
      </app-theme-page-section> -->
        <p class="p-mt-1 text-right">
          <button label="Manage Collections" class="p-button-outlined p-button-sm p-button-secondary" (click)="manageCollections()"></button>
        </p>
      </div>
    </section>
  }
  @if (building && collectionForAssets?.hasCollections) {
    <section class="no-print">
      <table class="table collections" aria-label="Collections">
        <thead>
          <tr>
            <th>Collection</th>
            <th>Assets</th>
          </tr>
        </thead>
        <tbody>
          @for (collection of collectionForAssets.collections; track collection; let i = $index) {
            <tr class="can-click" (click)="clickCollection(i)">
              <td><i class="mdi" [class.mdi-radiobox-blank]="!collection.selected" [class.mdi-radiobox-marked]="collection.selected"></i> {{ collection.title }}</td>
              <td class="assets">
                @for (a of collection.assets; track a.id) {
                  <span [title]="a.title" tooltipPosition="bottom">{{ a.title || a.id }}</span>
                }
              </td>
            </tr>
          }
          <tr>
            <td colspan="2" class="text-right">
              <button label="Manage Collections" class="p-button-outlined p-button-sm p-button-secondary p-mt-1" (click)="manageCollections()"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  }

  @if (building) {
    <section class="license no-print">
      <app-theme-page-section [label]="inProgressReview ? 'Review in progress' : 'Review date range'" (onToolbarClick)="toolbarClick($event)">
        <div class="info p-ml-1 p-mt-1">
          <div class="">Licensed At</div>
          <div class="">{{ building.license?.licensedAt | amDateFormat: 'ddd DD MMM YYYY' }}</div>
          <div class="">Start date</div>
          @if (inProgressReview) {
            <div class="">
              <h4>{{ startDate | amDateFormat: 'DD/MM/YYYY' }}</h4>
            </div>
          }
          @if (!inProgressReview) {
            <div class="">
              <!--<p-calendar [(ngModel)]="startDate" dateFormat="dd/mm/yy" (onSelect)="dateChange()"></p-calendar> -->
              <app-calendar [value]="startDate" (onSelectDate)="startDate = $event" />
              <i class="mdi mdi-calendar-today can-hover" title="Today" (click)="dateToday()"></i>
            </div>
          }
          <div class="">End date</div>
          @if (inProgressReview) {
            <div class="">
              <h4>{{ endDate | amDateFormat: 'DD/MM/YYYY' }}</h4>
            </div>
          }
          @if (!inProgressReview) {
            <div class="">
              <!--<p-calendar [(ngModel)]="endDate" dateFormat="dd/mm/yy"></p-calendar> -->
              <app-calendar [value]="endDate" (onSelectDate)="endDate = $event" />
            </div>
          }
        </div>
        @if (inProgressReview) {
          <div>
            <button title="Moved date ahead one month" label="Start another review" class="p-button-outlined p-button-sm p-button-secondary p-mt-1" (click)="completeReview()"></button>
          </div>
        }
      </app-theme-page-section>
    </section>
  }
  <!--
<section>
  <label>Select Quarter</label>
  <select class="form-control" [(ngModel)]="datesIndexSelected">
    <option *ngFor="let option of dates;let i = index" [value]="i">{{option.title}}</option>
  </select>
</section>
-->
  <section></section>

  @if (building && collectionForAssets?.selectedCollection) {
    <section class="mt-1 text-center no-print">
      <p-splitButton [label]="'Generate Report'" icon="mdi mdi-chart-areaspline-variant" (onClick)="generateReport()" [model]="generateItems"></p-splitButton>
    </section>
  }

  @if (runReport) {
    <section>
      <div class="mt-1">
        @if (startDate && endDate && building) {
          <app-insights-as-report [building]="building" [startDate]="startDate" [endDate]="endDate" [collection]="reportCollection" [useOrgLogo]="useOrgLogo" (onReportGenerated)="onReportWasGenerated($event)" [clearCache]="clearCache" (onReportClosed)="closeReport()"> </app-insights-as-report>
        }
      </div>
    </section>
  }
</article>
@if (isLoading) {
  <app-please-wait></app-please-wait>
}
